
import { defineComponent, ref, computed, onMounted } from 'vue'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faVuejs } from '@fortawesome/free-brands-svg-icons'
import router from '@/router'

import BaseLeftbar from '@/components/base/BaseLeftbar.vue'
import BaseExplorer from '@/components/base/BaseExplorer.vue'
import BaseMain from '@/components/base/BaseMain.vue'
import BaseFooter from '@/components/base/BaseFooter.vue'
import BaseDesktop from '@/components/base/BaseDesktop.vue'

export default defineComponent({
  components: {
    BaseLeftbar,
    BaseExplorer,
    BaseMain,
    BaseFooter,
    BaseDesktop
  },
  setup () {
    onMounted(() => {
      const getInnerVh = () => document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)

      getInnerVh()
      document.addEventListener('resize', getInnerVh)
    })

    const currentPage = computed(() => router.currentRoute.value.name)

    const icons = computed(() => ({
      faVuejs,
      faTimes
    }))

    const isThemeChanged = ref(false)
    const changeTheme = () => {
      const response = confirm('Change color theme?')
      if (response) {
        isThemeChanged.value = !isThemeChanged.value
      }
    }

    const isCollapsed = ref(false)
    const collapseParts = () => {
      const response = confirm(`Do you want to save the changes you made to ${String(currentPage.value)}.vue?`)
      if (response) {
        isCollapsed.value = true
      }
    }
    const isCloseEditor = ref(false)
    const closeEditor = () => isCloseEditor.value = true

    const openEditor = () => {
      isCollapsed.value = false
      isCloseEditor.value = false
      router.push({ path: '/' })
    }

    const isOpenExplorer = ref(true)
    const toggleExplorer = () => isOpenExplorer.value = !isOpenExplorer.value

    return {
      currentPage,
      icons,
      isCloseEditor,
      isCollapsed,
      collapseParts,
      openEditor,
      closeEditor,
      isThemeChanged,
      changeTheme,
      isOpenExplorer,
      toggleExplorer
    }
  }
})
